import React from "react";
import * as S from "./page-not-found.styles";
import { Simpletax } from "./constants";

export const PageNotFound = () => {
  const logo = Simpletax.logo;
  const logoWidth = Simpletax.width;

  return (
    <div>
      <title>404 - Page not found</title>
      <S.SimpletaxLogo
        alt={logo}
        src={logo}
        width={logoWidth}
      ></S.SimpletaxLogo>
      <S.Container>
        <S.h1>404</S.h1>
        <S.span>Page not found</S.span>
        <S.para>
          <p>Did you get lost? Or just lost a receipt somewhere?</p>
          <p>
            That receipt, I believe is in the left pocket of your favorite blue
            jacket.
          </p>
          <p>
            When you are done searching for it, just go back to{" "}
            <a href="https://www.gosimpletax.com/">Simpletax</a> this way.
          </p>
        </S.para>
      </S.Container>
    </div>
  );
};
